import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useHaptics } from "@/haptics/HapticsProvider";

function RoundedHexShape({ className }) {
  return (
    <svg className={className} viewBox="0 0 56 56" aria-hidden="true">
      <path d="M19 3h18q5 0 7.5 4l9 16q2.5 5 0 10l-9 16q-2.5 4-7.5 4H19q-5 0-7.5-4l-9-16q-2.5-5 0-10l9-16Q14 3 19 3Z" />
    </svg>
  );
}

function isRouteActive(pathname, to) {
  if (to === "/") return pathname === "/";
  return pathname === to || pathname.startsWith(`${to}/`);
}

function tutorialTarget(id) {
  if (id === "home") return "nav-home";
  if (id === "live") return "nav-live";
  if (id === "table") return "nav-table";
  if (id === "series") return "nav-series";
  return undefined;
}

export default function NativeBottomNav({ items, isHidden, onCreate }) {
  const { pathname } = useLocation();
  const { tap } = useHaptics();

  const handleCreate = React.useCallback(() => {
    tap();
    onCreate();
  }, [onCreate, tap]);

  return (
      <nav
          aria-label="Huvudnavigation"
          className="native-v3-dock-shell lg:hidden"
          data-hidden={isHidden ? "true" : "false"}
        >
          <ul className="native-v3-dock">
          {items.map(({ id, to, label, icon: Icon, isCenter, disabled }) => {
            const active = !isCenter && !disabled && isRouteActive(pathname, to);

            return (
              <li
                key={id}
                className={`native-v3-dock-slot ${isCenter ? "native-v3-dock-slot-create" : ""}`}
              >
                {isCenter ? (
                  <button
                    type="button"
                    aria-label="Skapa eller öppna matchprotokoll"
                    data-tutorial-target="nav-new"
                    data-native-onboarding-target="create-protocol"
                    onClick={handleCreate}
                    className="native-v3-dock-item native-v3-dock-create"
                  >
                    <RoundedHexShape className="native-v3-dock-create-shape" />
                    <Icon aria-hidden="true" className="native-v3-dock-icon" />
                  </button>
                ) : disabled ? (
                  <span
                    aria-disabled="true"
                    className="native-v3-dock-item native-v3-dock-disabled"
                  >
                    <Icon aria-hidden="true" className="native-v3-dock-icon" />
                    <span className="native-v3-dock-label">{label}</span>
                  </span>
                ) : (
                  <NavLink
                    to={to}
                    end={to === "/"}
                    aria-label={label}
                    data-tutorial-target={tutorialTarget(id)}
                    className={[
                      "native-v3-dock-item native-v3-dock-route",
                      active ? "native-v3-dock-route-active" : "",
                    ].filter(Boolean).join(" ")}
                  >
                    <span className="native-v3-dock-icon-wrap">
                      <Icon aria-hidden="true" className="native-v3-dock-icon" />
                    </span>
                    <span className="native-v3-dock-label">
                      {label}
                    </span>
                  </NavLink>
                )}
              </li>
            );
          })}
          </ul>
      </nav>
  );
}
